import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import Header from '../../components/Header';
import DayFilter from '../../components/DayFilter';
import withGoBack from '../../common/withGoBack';
import withNotify from '../../common/withNotify';
import withCaseFilter from '../../common/withCaseFilter';
import withSelectCaseDate from '../../common/withSelectCaseDate';
import { onGoBack } from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';

class DayFilterCase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {}
    };
  }

  // _checkValidation = (filterData) => {
  //   try {
  //     if (Object.keys(filterData).length) {
  //       return !!Object.keys(filterData).filter((field) =>
  //       !!(filterData[field].length || (filterData[field] !== ''))).length;
  //     } return false;
  //   } catch (e) {
  //     Bugsnag.notify(e);
  //   }
  // }

  _onApplyFilter = async () => {
    try {
      const { setCaseFilter, caseFilter } = this.props;
      const { filterData } = this.state;

      const filterValue = Object.assign(caseFilter, filterData);
      _.mapKeys(filterValue, (value, key) => {
        if (_.isArray(value) && _.isEmpty(value)) delete filterValue[key];
      });
      for (const value in filterData) {
        if (filterData[value].length === 0) {
          delete filterData[value];
        }
      }
      this._onGoBack();
      setCaseFilter(filterValue);
      browserHistory.push('/manage-cases');

      // if (this._checkValidation(caseFilter)) {
      //   this._onGoBack();
      //   setCaseFilter(filterValue);
      //   browserHistory.push('/manage-cases');
      // } else {
      //   notify({ type: 'error', message: 'You must select at least one search field' });
      // }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = (data) => {
    try {
      this.setState({ filterData: data });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  // _onClearFilter = () => {
  //   try {
  //     const { setCaseFilter } = this.props;
  //     this.setState({ filterData: {} });
  //     setCaseFilter({});
  //   } catch (e) {
  //     Bugsnag.notify(e);
  //   }
  // }

  _goBack = () => {
    try {
      const {
        goBack
      } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { filterData } = this.state;
    const { caseFilter, selectCaseDate } = this.props;
    return (
      <div className="site-wrapper resizer-class">
        <Header
          actionButton={{ title: 'Apply Filter', onClick: this._onApplyFilter }}
          title="Day Filter"
          goBack={this._goBack}
        />
        <DayFilter
          previousData={filterData}
          onFilter={(data) => this._onFilter(data)}
          selectedFilter={caseFilter}
          dayCaseFilter={filterData}
          selectCaseDate={selectCaseDate}
        />
      </div>
    );
  }
}

export default withSelectCaseDate(
  withCaseFilter(
    withNotify(
      withGoBack(
        DayFilterCase
      )
    )
  )
);
